import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { TagsList } from '../News/NewsPrimary';

import './news-post-tags.scss';

class NewsPostTags extends PureComponent {
  render() {
    return (
      <div className="news-post-tags">
        <div className="container">
          <div className="static-content">
            <TagsList
              canNavigate={true}
              tags={this.props.tags}
              pathname={this.props.pathname}
            />
          </div>
        </div>
      </div>
    );
  }
}

NewsPostTags.propTypes = {
  tags: PropTypes.array,
  pathname: PropTypes.string.isRequired
};

export default NewsPostTags;



// WEBPACK FOOTER //
// ./src/components/NewsPost/NewsPostTags.js